<template>
  <!-- {{ value }}} -->
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t('5005.bankinformation.bankinformation') }}</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="12" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="insert_bankdetails.BankName" :label="$t('5005.bankinformation.name')"
            name="Bank Name" id='Bank Name' :rules="{ required: false, alphabet: true }" :required-icon="false" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="insert_bankdetails.BankAcNo" :label="$t('5005.bankinformation.number')"
            name="A/C No" id='A/C No' :rules="{ required: false, numeric: true }" :required-icon="false"
            @change="AccountNoChk" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="insert_bankdetails.ReBankAcNo" :label="$t('5005.bankinformation.renumber')"
            name="Re Enter A/c No" id='Re Enter A/c No' :rules="{ required: false, numeric: true }"
            :required-icon="false" />
          <p v-if="showError" class="err_msg_style">Account No Must Be Same</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput v-model="insert_bankdetails.BankBranch" :label="$t('5005.bankinformation.branch')" name="Branch"
            id='Branch' :rules="{ required: false, alphanumeric: true }" :required-icon="false" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput v-model="insert_bankdetails.IFSC" :label="$t('5005.bankinformation.ifsc')" name="IFSC" id='IFSC'
            :rules="{ required: false, alphanumeric: true }" :required-icon="false" />
        </div>
      </b-col>
    </b-row>
    <Toast />
  </div>
</template>

<script lang="ts">
import { value } from "dom7";
import { defineComponent, ref, reactive, onMounted, computed } from "vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import service from "../../../../modules/Inventory/Service/SupplierMaster";
import { useToast } from "primevue/usetoast";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
export default defineComponent({
  components: {
    TextInput,
  },

  props: {
    value: {},
  },

  setup(props, { emit }) {
    const insert_bankdetails = reactive({
      BankName: "",
      BankAcNo: "",
      ReBankAcNo: "",
      BankBranch: "",
      IFSC: "",
    });
    const toast = useToast();
    let session: any = localStorage.getItem("UsersData");
    const router = useRoute();
    const EditID = router.query.Id;
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);

    onMounted(() => {
      Object.assign(insert_bankdetails, props.value);
      input();
    });
    function input() {
      console.log("test");
      emit("update:modelValue", insert_bankdetails);
    }

    const showError = computed(() => {
      return insert_bankdetails.BankAcNo !== insert_bankdetails.ReBankAcNo;
    });
    // function checkAccountNumber() {
    //   // debugger;
    //   // if (insert_bankdetails.BankAcNo == insert_bankdetails.ReBankAcNo) {
    //   //   console.log('match');
    //   // }
    //   // else {
    //   //   // alert("show")
    //   //   showError.value = true;
    //   // }
    // }
    async function AccountNoChk() {
      try {
        debugger;
        const response = await service.gettable();
        console.log(response["result"]);
        let condition = ''
        if (EditID) {
          condition = ' && items.Id!=' + EditID + ''
        }
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == HospitalId && items.BankAcNo == insert_bankdetails.BankAcNo && items.Id != (EditID || 0))
        if (response["result"].length > 0) {
          toast.add({
            severity: "warn",
            summary: "This AccountNo. is Already Used by another supplier!",
            detail: "",
            life: 3000,
          });
          insert_bankdetails.BankAcNo = ""
        }



      }
      catch (error) {
        console.log(error)
      }

    }

    return {
      insert_bankdetails,
      input,
      // checkAccountNumber,
      showError,
      AccountNoChk,
    };
  },
});
</script>
